var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 14.67c0 3.32-2.35 4.67-5.22 3.02l-1.28-.74c-.31-.18-.5-.51-.5-.87V7.92c0-.36.19-.69.5-.87l1.28-.74C15.65 4.66 18 6.01 18 9.33v5.34zM9.999 15.222c0 .39-.42.63-.75.43l-1.1-.64c-2.87-1.65-2.87-4.37 0-6.02l1.1-.64c.33-.19.75.05.75.44v6.43z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldArrowLeft);
export default __webpack_public_path__ + "static/media/vuesax-bold-arrow-left.95503e51b6f4d15759efcdd728929629.svg";
export { ForwardRef as ReactComponent };